import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsShellWrapper from '../SettingsShellWrapper.vue';
import Index from './Index.vue';

// Administrator only, behind the same flag the controller checks: every write
// and every connection probe is administrator-gated server-side by
// Tola::AI::MCP::RemoteServerPolicy, and the whole controller 403s when
// `tola_ai_mcp_client` is off. `permissions` is what the router guard reads;
// `featureFlag` is what the sidebar reads to decide whether to offer the row.
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/mcp-connectors'),
      component: SettingsShellWrapper,
      children: [
        {
          path: '',
          name: 'settings_mcp_connectors',
          component: Index,
          meta: {
            featureFlag: FEATURE_FLAGS.TOLA_AI_MCP_CLIENT,
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
